import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import app from './modules/app'
import setting from './modules/setting'
import profile from './modules/profile'
import auth from './modules/auth'
import user from './modules/user'
import inventory from './modules/inventory'
import store from './modules/store'
import item from './modules/item'
import user_order from './modules/user_order'
import listing from './modules/listing'
import marunage from './modules/marunage'
import item_cache from './modules/item_cache'
import shipping from './modules/shipping'
import shipping_crobo_order from './modules/shipping_crobo_order'
import shipping_address from './modules/shipping_address'
import shipping_item from './modules/shipping_item'
import shipping_hscode from './modules/shipping_hscode'
import shipping_box from './modules/shipping_box'
import listing_html from './modules/listing_html'
import insurance from './modules/insurance'
import item_category from './modules/item_category'
import notification from './modules/notification'
import axios from './modules/axios'

Vue.use(Vuex)

const vuex = new Vuex.Store({
    modules: {
        app,
        setting,
        profile,
        axios,
        auth,
        user,
        inventory,
        store,
        item,
        user_order,
        listing,
        marunage,
        item_cache,
        shipping,
        shipping_crobo_order,
        shipping_address,
        shipping_item,
        shipping_hscode,
        shipping_box,
        listing_html,
        insurance,
        item_category,
        notification,
    },
    getters
})

export default vuex

